import React, { Component } from 'react';
import { Field, formValueSelector } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import PreviewModal from './PreviewModal/PreviewModal';
import { getExploreTheme } from '../../../helpers/iOSthemeLayoutHelper/getExploreTheme';
import ToolTipSection from '../../Common/ToolTipSection/ToolTipSection';
import cp from '../../../components/commonStyle.css';
import s from './IOSLayoutSettingsForm.css';
import messages from '../../../locale/jsonMessages';
class ExploreSettings extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      themes: [],
      isExplore: false
    }
  }

  openPreviewModal = () => {
    const { places, recommend, banner, mostViewed } = this.props;
    const { placesOrder, recommendOrder, mostViewedOrder, bannerOrder, themeType } = this.props;
    const themes = getExploreTheme({ places, recommend, banner, mostViewed, placesOrder, recommendOrder, mostViewedOrder, bannerOrder, themeType });
    this.setState({ showModal: true, themes, isExplore: true });
  }

  closePreviewModal = () => {
    this.setState({ showModal: false, themes: [], isExplore: false });
  }

  themeOptions = ({ name, label }) => {
    const { formatMessage } = this.props.intl;
    return (
      <>
        <ControlLabel className={cx('commonLabelText', s.spaceMarginBottom0)}>
          {label}
        </ControlLabel>
        <Field name={name} type="text" inputClass='commonSelectField' component={CommonFormComponent}>
          <option value={1}>{formatMessage(messages.theme1)}</option>
          <option value={2}>{formatMessage(messages.theme2)}</option>
          <option value={3}>{formatMessage(messages.theme3)}</option>
          <option value={4}>{formatMessage(messages.theme4)}</option>
        </Field>
        <Field name={`${name}Order`}
          type="text" component={CommonFormComponent}
          maxLength={2}
          placeholder={formatMessage(messages.order)}
          inputClass='commonInputField' />
      </>
    )
  }


  render() {
    const { formatMessage } = this.props.intl;
    const { showModal, themes, isExplore } = this.state;

    const exploreData = [
      { name: 'recommend', label: formatMessage(messages.recommend) },
      { name: 'mostViewed', label: formatMessage(messages.mostViewedPage) },
      { name: 'places', label: formatMessage(messages.places) },
      { name: 'banner', label: formatMessage(messages.banner) },
    ];

    return (
      <div>
        <PreviewModal
          show={showModal}
          closePreviewModal={this.closePreviewModal}
          openPreviewModal={this.openPreviewModal}
          themes={themes}
          isExplore={isExplore}
          title={formatMessage(messages.explorePage)}
        />
        <div>
          <div className={cx(cp.spaceBottom4, 'tooltipLabelContainer')}>
            <span className={cx(cp.fontWeightBold, cp.commonSubTitleText)}>
              <FormattedMessage  {...messages.explorePage} /></span>
            <ToolTipSection label={formatMessage(messages.exploreToolTip)} />
          </div>
          <div className='oneColumnGrid'>
            {
              exploreData?.map((item, key) => {
                return (
                  <div className={s.themeRowContainer} key={key}>
                    {this.themeOptions(item)}
                  </div>
                )
              })
            }
          </div>
        </div>
        <div className={cx(s.spaceTop4, s.previewContainer)}>
          <span className={s.iosPreviewLink} onClick={() => this.openPreviewModal()}>{formatMessage(messages.preview)}</span>
        </div>
      </div>
    );
  }
}

const selector = formValueSelector('IOSLayoutSettingsForm'); // <-- same as form name

const mapState = (state) => ({
  places: selector(state, 'places'),
  recommend: selector(state, 'recommend'),
  banner: selector(state, 'banner'),
  mostViewed: selector(state, 'mostViewed'),
  placesOrder: selector(state, 'placesOrder'),
  recommendOrder: selector(state, 'recommendOrder'),
  bannerOrder: selector(state, 'bannerOrder'),
  mostViewedOrder: selector(state, 'mostViewedOrder'),
  themeType: selector(state, 'themeType'),
});

const mapDispatch = {};

export default injectIntl(withStyles(cp, s)(connect(mapState, mapDispatch)(ExploreSettings)));